import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PERMISSIONS } from "./permissionsList";
import { API_BASE_URL } from "../config";
import "./AdminShared.css";

export default function AddAdmin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "subAdmin",
    permissions: [],
  });
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (!adminInfo) return navigate("/admin");
  }, [navigate]);

  const toggle = (k) => {
    setForm((p) => {
      const has = p.permissions.includes(k);
      return { ...p, permissions: has ? p.permissions.filter(x => x !== k) : [...p.permissions, k] };
    });
  };

  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
    try {
      const stored = JSON.parse(localStorage.getItem("adminInfo") || "null");
      if (!stored || !stored.token) return setMsg({ error: "🔒 Session verification failed" });

      const res = await fetch(`${API_BASE_URL}/admin/create-admin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${stored.token}`,
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (!res.ok) return setMsg({ error: data.message || "Deployment failed" });
      setMsg({ success: "✅ Operator successfully registered to matrix." });
      setForm({ name: "", email: "", password: "", role: "subAdmin", permissions: [] });
      setTimeout(() => navigate("/admin/view-admins"), 1500);
    } catch (err) {
      setMsg({ error: "⚠️ System connection error" });
    }
  };

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <button className="admin-back-btn" onClick={() => navigate("/admin/panel")}>←</button>
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Identity Registry</h1>
        </div>
        <div className="module-badge" style={{ background: '#475569' }}>Security</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#475569' }}></div>
            Registry Mode: New Operator Initialization
          </div>
        </div>

        <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
           <form onSubmit={submit}>
                <div className="admin-form-elite" style={{ marginBottom: '40px' }}>
                    <label>
                        Operator Full Name
                        <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required placeholder="Enter legal identity" />
                    </label>

                    <label>
                        Secure Communication Node (Email)
                        <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required placeholder="operator@flytutor.in" />
                    </label>

                    <label className="full-width-field">
                        Access Key (Password)
                        <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required placeholder="Initialize secure password" />
                    </label>
                </div>

                <div style={{ padding: '30px', background: '#f8fafc', borderRadius: '20px', border: '1px solid #e2e8f0' }}>
                    <h3 style={{ margin: '0 0 20px 0', fontSize: '1.1rem', fontWeight: 800, color: '#0f172a' }}>Permission Logic Matrix</h3>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: '15px' }}>
                        {PERMISSIONS.map(p => (
                            <label key={p.key} style={{ 
                                display: "flex", gap: '12px', alignItems: "center", padding: '12px', 
                                background: form.permissions.includes(p.key) ? '#fff' : 'transparent',
                                border: form.permissions.includes(p.key) ? '2px solid #6366f1' : '1px solid #e2e8f0',
                                borderRadius: '12px', cursor: 'pointer', transition: 'all 0.2s ease',
                                margin: 0
                            }}>
                                <input 
                                    type="checkbox" 
                                    className="status-tag" 
                                    style={{ width: '18px', height: '18px', margin: 0 }}
                                    checked={form.permissions.includes(p.key)} 
                                    onChange={() => toggle(p.key)} 
                                />
                                <span style={{ fontSize: '0.85rem', fontWeight: 600, color: form.permissions.includes(p.key) ? '#1e293b' : '#64748b' }}>
                                    {p.label}
                                </span>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="admin-submit-area" style={{ display: 'flex', gap: '15px' }}>
                    <button type="button" className="btn-update" style={{ padding: '16px 30px', background: '#f1f5f9', border: 'none' }} onClick={() => navigate("/admin/panel")}>
                        Cancel Registry
                    </button>
                    <button type="submit" className="btn-primary-elite" style={{ background: '#475569' }}>
                        Deploy Operator Identity
                    </button>
                </div>

                {msg?.error && <div style={{ marginTop: '20px', padding: '15px', background: '#fef2f2', color: '#b91c1c', borderRadius: '12px', fontWeight: 700, textAlign: 'center' }}>{msg.error}</div>}
                {msg?.success && <div style={{ marginTop: '20px', padding: '15px', background: '#f0fdf4', color: '#166534', borderRadius: '12px', fontWeight: 700, textAlign: 'center' }}>{msg.success}</div>}
           </form>
        </div>
      </div>
    </div>
  );
}
